var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
function SvgFiYoutube(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.7825 5.34967C18.6835 4.95418 18.4819 4.59182 18.1981 4.29918C17.9142 4.00654 17.5581 3.794 17.1658 3.68301C15.7325 3.33301 9.99917 3.33301 9.99917 3.33301C9.99917 3.33301 4.26584 3.33301 2.83251 3.71634C2.44021 3.82733 2.08416 4.03987 1.8003 4.33251C1.51644 4.62515 1.31483 4.98752 1.21584 5.38301C0.95352 6.83764 0.825204 8.31327 0.832508 9.79134C0.823157 11.2805 0.951481 12.7674 1.21584 14.233C1.32497 14.6162 1.5311 14.9648 1.81429 15.2451C2.09749 15.5254 2.44819 15.7279 2.83251 15.833C4.26584 16.2163 9.99917 16.2163 9.99917 16.2163C9.99917 16.2163 15.7325 16.2163 17.1658 15.833C17.5581 15.722 17.9142 15.5095 18.1981 15.2168C18.4819 14.9242 18.6835 14.5618 18.7825 14.1663C19.0428 12.7227 19.1711 11.2583 19.1658 9.79134C19.1752 8.30214 19.0469 6.81526 18.7825 5.34967V5.34967Z",
    stroke: "#B6BBC6",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.125 12.5164L12.9167 9.79141L8.125 7.06641V12.5164Z",
    stroke: "#B6BBC6",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFiYoutube);
export default __webpack_public_path__ + "static/media/fi_youtube.a8f1ccbf8dbd7b1b83b7dda2ec3cb290.svg";
export { ForwardRef as ReactComponent };